import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from 'src/redesign/features/AttendeesSidebar/tabs/EmailDelivery/store/constants';
import { fetchEmailDeliveryActivitiesApi } from 'src/redesign/features/AttendeesSidebar/tabs/EmailDelivery/store/api';
import { Attendee } from 'src/types/types';

export const getEmailDeliveryData = createAsyncThunk(
  actionTypes.GET_EMAIL_DELIVERY_DATA,
  async (id: Attendee['id'], { getState }) => await fetchEmailDeliveryActivitiesApi(getState(), id),
);
